import { SideBarCategory } from '../[...category]/_components/SideBarCategory'
import {
  getCategoriesByUrl,
} from '@/lib/actions/getCategories'
import { getProductsPriceRange } from '@/lib/actions/getProducts'
import { useEffect, useState } from 'react'


interface Props {
  slugArr: string[]
  searchParams: Record<string, string>
}

export default function DrawerFilterContent({ slugArr, searchParams }: Props) {
  const [content, setContent] = useState<any>(null)
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    async function fetchData() {
      try {
        const slugForApi = slugArr.join('_')
        const category = await getCategoriesByUrl(slugForApi)
        console.log('катгория в фильтре мобилки', category)
        if (!category) {
          setContent(<div>Категория не найдена</div>)
          return
        }

        const priceRange = await getProductsPriceRange({
          category_id: String(category.id),
          ...searchParams
        })
         console.log('катгория в фильтре мобилки прайс', priceRange)
        setContent(
          <SideBarCategory
            className="px-6 w-full"
            initialRange={priceRange}
            categoryId={category.id}
          />
        )
      } catch (error) {
        console.error('Filter error:', error)
        setContent(<div>Ошибка загрузки фильтров</div>)
      } finally {
        setLoading(false)
      }
    }

    fetchData()
  }, [slugArr, searchParams])

  if (loading) return <div>Загрузка фильтров...</div>
  return content
}
